$(function () {
    $('.woocommerce-message').on('click', function () {
        $(this).fadeOut();
    });
    $('.showcoupon').on('click', function () {
        $('.checkout_coupon').slideToggle();
        return false;
    });
});
